import React from 'react';
import { Button } from 'antd-mobile';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import './index.scss';
const Vh5Cropper = props => {
	let { previewClassName, imgData, cropperCallback, imgType, onClose, aspectRatio = 1 } = props;
	let globalCropper = null;
	function onCropper() {
		if (typeof globalCropper.getCroppedCanvas() === 'undefined') {
			return;
		}
		//image/png, image/pjpeg
		let canvas = globalCropper.getCroppedCanvas();
		let p = (400 / canvas.width) * 0.2;
		cropperCallback && globalCropper && cropperCallback(globalCropper.getCroppedCanvas().toDataURL(imgType || 'image/jpeg'), p);
	}
	return (
		<div className="vcropper-wrap">
			<Cropper
				className="_cropper-wrap"
				aspectRatio={aspectRatio}
				preview={'.' + (previewClassName || 'preview')}
				guides={false}
				src={imgData}
				ref={cropper => {
					globalCropper = cropper;
				}}
			/>
			<div className="btn-list">
				<Button className="normal-btn" size="small" inline onClick={onClose}>
					取消
				</Button>
				<Button className="primary-btn" type="primary" size="small" inline onClick={onCropper}>
					确定
				</Button>
			</div>
		</div>
	);
};
export { Vh5Cropper };
